import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UploadConfirmModalStore {
  dontShowAgain: boolean;
  setDontShowAgain: (value: boolean) => void;
}

export const useUploadConfirmModal = create<UploadConfirmModalStore>()(
  persist(
    set => ({
      dontShowAgain: false,
      setDontShowAgain: (value: boolean) => set({ dontShowAgain: value })
    }),
    {
      name: 'upload-confirm-modal-preferences'
    }
  )
);
